import httpClient from '../../shared/services/httpClient';

export const header = () => {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  };
};

export default httpClient;
